﻿function initAnimation() {


    //All animation will be scrollTrigger based.
    //So we don't need a master timeline


    function animateHeading() {
        var tl = gsap.timeline();
        tl.set('#mainHeading', { autoAlpha: 1 });
        tl.set('#mainTagline', { autoAlpha: 1 })
        tl.from('#mainHeading', {
            x: '100',
            opacity: 0,
            duration: .6,
            delay: .5
        });
        tl.from('#mainTagline', {
            x: '-100',
            opacity: 0,
            duration: .6
        }, '<')
    }

    function section2() {
        gsap.from('#s1', {
            x: -100, opacity: 0, scrollTrigger: {
                //markers: true,
                start: 'top 80%',
                end: 'center 80%',
                trigger: '#s1',
                scrub: 1,
                once: true
            }
        });

        gsap.from('#s2', {
            x: 100, opacity: 0, scrollTrigger: {
                //markers: true,
                start: 'top 80%',
                end: 'bottom 80%',
                trigger: '#s2',
                scrub: 1,
                once: true
            }
        });

        gsap.from('#s3', {
            x: -100, opacity: 0, scrollTrigger: {
                //markers: true,
                start: 'top 80%',
                end: 'center 80%',
                trigger: '#s3',
                scrub: 1,
                once: true
            }
        });

        gsap.from('#s4', {
            x: 100, opacity: 0, scrollTrigger: {
                //markers: true,
                start: 'top 80%',
                end: 'center 80%',
                trigger: '#s4',
                scrub: 1,
                once: true
            }
        });

    }



    function animateLeadershipTransitionsReport() {

    }

    function bottomCTA() {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '#s8',
                //markers: true,
                start: 'top 85%',
                once: true
            }
        });

        tl.from('#s9', { x: -100, opacity: 0 })
            .from('#s10', { x: 100, opacity: 0 }, '<')
    }

    function animateGraph() {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '#graph-trigger',
                //markers: true,
                start: 'top 60%',
                once: true
            }
        });

        tl.from('#bar_01_green > rect', { width: 0, duration: .7 })
            .from('#stat_01', { opacity: 0, duration: .2 }, '<.5')
            .from('#bar_02_purple > rect', { width: 0, duration: .7 })
            .from('#stat_02', { opacity: 0, duration: .2 }, '<.5')
            .from('#bar_03_yellow > rect', { width: 0, duration: .7 })
            .from('#stat_03', { opacity: 0, duration: .2 }, '<.5')

    }

    animateHeading();
    section2();
    bottomCTA();
    animateGraph();
}
initAnimation();

function activateReportSection() {
    const report1Container = document.getElementById('report1Container');
    const report2Container = document.getElementById('report2Container');
    const report3Container = document.getElementById('report3Container');
    const report4Container = document.getElementById('report4Container');
    const reports = document.querySelectorAll('.displayContainer .report');
    const controlsIcons = document.querySelectorAll('.reportIcons');

    let screensize = window.innerWidth;
    const master = gsap.timeline({});
    let activeSlide, oldSlide;

    function generateControllerTweens() {
        const purpleTimeline = gsap.timeline({ paused: true });
        const greenTimeline = gsap.timeline({ paused: true });
        const blueTimeline = gsap.timeline({ paused: true });
        const yellowTimeline = gsap.timeline({ paused: true });

        let purpleExit = 0;
        let greenExit = 0;
        let blueExit = 0;
        let redExit = 0;

        gsap.set('.reportControllerHoverBar', { scaleX: 0, transformOrigin: 'left center' });

        //Purple tweens
        purpleTimeline.to('.reportControllerHoverBar.purple', { scaleX: 1 }).addPause('exit');
        purpleExit = purpleTimeline.duration();
        purpleTimeline.to('.reportControllerHoverBar.purple', { x: 335 });

        $('#report1').on('mouseenter', function () {
            if (purpleTimeline.time() < purpleExit) {
                purpleTimeline.play();
            }
            else {
                purpleTimeline.restart();
            }
        }).on('mouseleave', function () {
            if (purpleTimeline.time() < purpleExit) {
                purpleTimeline.reverse();
            }
            else {
                purpleTimeline.play();
            }
        });

        //blue tweens
        blueTimeline.to('.reportControllerHoverBar.cyan', { scaleX: 1 }).addPause('exit');
        blueExit = blueTimeline.duration();
        blueTimeline.to('.reportControllerHoverBar.cyan', { x: 335 });

        $('#report2').on('mouseenter', function () {
            if (blueTimeline.time() < blueExit) {
                blueTimeline.play();
            }
            else {
                blueTimeline.restart();
            }
        }).on('mouseleave', function () {
            if (blueTimeline.time() < blueExit) {
                blueTimeline.reverse();
            }
            else {
                blueTimeline.play();
            }
        });

        //green tweens
        greenTimeline.to('.reportControllerHoverBar.green', { scaleX: 1 }).addPause('exit');
        greenExit = greenTimeline.duration();
        greenTimeline.to('.reportControllerHoverBar.green', { x: 335 });

        $('#report3').on('mouseenter', function () {
            if (greenTimeline.time() < greenExit) {
                greenTimeline.play();
            }
            else {
                greenTimeline.restart();
            }
        }).on('mouseleave', function () {
            if (greenTimeline.time() < greenExit) {
                greenTimeline.reverse();
            }
            else {
                greenTimeline.play();
            }
        });

        //yellow tweens
        yellowTimeline.to('.reportControllerHoverBar.yellow', { scaleX: 1 }).addPause('exit');
        yellowExit = yellowTimeline.duration();
        yellowTimeline.to('.reportControllerHoverBar.yellow', { x: 335 });

        $('#report4').on('mouseenter', function () {
            if (yellowTimeline.time() < redExit) {
                yellowTimeline.play();
            }
            else {
                yellowTimeline.restart();
            }
        }).on('mouseleave', function () {
            if (yellowTimeline.time() < redExit) {
                yellowTimeline.reverse();
            }
            else {
                yellowTimeline.play();
            }
        });
    }
    generateControllerTweens();

    activeSlide = report4Container;

    //Click Events for controllers
    $('#report1').on('click', function (event) {
        removeActiveClassController();
        $('#report1 .reportIcons').addClass('activeIcon');

        if (report1Container === activeSlide) {
            return;
        }

        removeActiveClass();

        oldSlide = activeSlide;
        activeSlide = report1Container;
        activeSlide.classList.add('active')

        if (master.isActive()) {
            master.killTweensOf(".box");
        }

        tweenContainer(report1Container);

    })
    $('#report2').on('click', function (event) {
        removeActiveClassController();
        $('#report2 .reportIcons').addClass('activeIcon');

        if (report2Container === activeSlide) {
            return;
        }

        removeActiveClass();

        oldSlide = activeSlide;
        activeSlide = report2Container;
        activeSlide.classList.add('active');

        if (master.isActive()) {
            master.killTweensOf(".box");
        }

        tweenContainer(report2Container);
    })
    $('#report3').on('click', function (event) {

        removeActiveClassController();
        $('#report3 .reportIcons').addClass('activeIcon');

        if (report3Container === activeSlide) {
            return;
        }

        removeActiveClass();

        oldSlide = activeSlide;
        activeSlide = report3Container;
        activeSlide.classList.add('active');

        if (master.isActive()) {
            master.killTweensOf(".box");
        }

        tweenContainer(report3Container);
    })
    $('#report4').on('click', function (event) {

        removeActiveClassController();
        $('#report4 .reportIcons').addClass('activeIcon');

        if (report4Container === activeSlide) {
            return;
        }

        removeActiveClass();

        oldSlide = activeSlide;
        activeSlide = report4Container;
        activeSlide.classList.add('active');

        if (master.isActive()) {
            master.killTweensOf(".box");
        }

        tweenContainer(report4Container);
    })

    //Helper Functions  
    function removeActiveClassController() {
        for (const controller of controlsIcons) {
            controller.classList.remove('activeIcon');
        }
    }
    //Container animations
    function removeActiveClass() {
        for (const report of reports) {
            report.classList.remove('active');
        }
    }
    function tweenContainer(container) {
        const containerID = container.id;
        master.fromTo(container, { opacity: 0, y: 15 }, { opacity: 1, y: 0 });
        master.from('#' + containerID + ' .reportHeader', { opacity: 0, x: 50 }, '<');
        master.from('#' + containerID + ' .reportBody', { opacity: 0, x: 50 }, '<');
        master.from('#' + containerID + ' .reportUnorderedList li', { opacity: 0, x: -20, stagger: .1, duration: .2 })
    }
}
activateReportSection()